import { AxiosInstance } from "axios";
import { User } from "../types";

export const basePath = "/tokens";

// All the paths for this api domain.
export const tokenPaths = {
  refreshJwt: () => basePath + "/refresh-lite",
};

class TokenApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }
  // Refresh JWT token.
  // POST /tokens/refresh-lite
  refreshJwt = (refreshToken: string, communityId: number) => {
    return this.api.post<User>(
      tokenPaths.refreshJwt(),
      { communityId },
      {
        headers: {
          "X-Cotribute-Refresh-Token": refreshToken,
        },
      }
    );
  };
}

export default TokenApi;
